export default __webpack_public_path__ + "static/media/pending-icon.86d18305.svg";